export const hasAccess = (roles: string[], accessType: string | string[]) => {
  if (roles) {
    const canAccess = roles.some(
      (role) =>
        role === accessType ||
        (Array.isArray(accessType) && accessType.includes(role)) ||
        role === 'my-account'
    );
    return canAccess;
  }
};
